// extracted by mini-css-extract-plugin
export var cardLayout = "_9y-1";
export var paginationContainer = "_9y-0";